import { connect } from "react-redux";

import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { FormActionHandler } from "../../../Internals/FormActionHandlers/FormActionHandler";
import { NdsSverkaParams } from "../../../../../../Common/NdsPlusApiClient/INdsPlusApiClient";

import { NdsSverkaCheckWrapper, NdsSverkaCheckWrapperProps } from "./NdsSverkaCheckWrapper";

interface NdsSverkaCheckWrapperContainerProps
    extends Omit<
        NdsSverkaCheckWrapperProps,
        "getSverkaNdsPlusParamsFromFuf" | "getNdsSverkaPageUrl" | "fetchCheckStatus"
    > {
    getSverkaNdsPlusParams: FormActionHandler;
}

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: NdsSverkaCheckWrapperContainerProps) => ({
    getSverkaNdsPlusParamsFromFuf: function () {
        return dispatch((_, __, form) => {
            // @ts-expect-error: обычно хелперы вызываются через executeFormActionHandler, но тогда нужно добавлять ненужные здесь контексты и пропсы
            const params: NdsSverkaParams = ownProps.getSverkaNdsPlusParams({ publicForm: form.publicForm });

            return params;
        });
    },

    getNdsSverkaPageUrl: function (params: NdsSverkaParams) {
        return dispatch((_, __, form) => form.ndsPlusApiClient.getNdsSverkaPageUrl(params));
    },

    fetchCheckStatus: async (params: NdsSverkaParams) =>
        await dispatch(async (_, __, form) => await form.ndsPlusApiClient.getNdsSverkaStatus(params)),
});

export const NdsSverkaCheckWrapperContainer = connect(undefined, mapDispatchToProps)(NdsSverkaCheckWrapper);
